import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, inject, PLATFORM_ID } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { KbMyPriceListService } from 'src/app/services/feature/myPriceList/kb-my-price-list.service';
import { OccEndpointsService } from '@spartacus/core';
import { isPlatformBrowser } from '@angular/common';

export interface DownloadItem {
  download: string;
  filename: string;
}
@Component({
  selector: 'app-kb-my-price-list',
  templateUrl: './kb-my-price-list.component.html',
  styleUrls: ['./kb-my-price-list.component.scss'],
  standalone: false
})
export class KbMyPriceListComponent {
  url: any;
  selectAll: boolean = false;
  sub = new Subscription();
  isMobile: boolean;
  Pricing: boolean[] = [];
  baseUrl: string = '';
  pricelist$: Observable<any> = this.service.getApi();
  downloadError: boolean;

  platformId = inject(PLATFORM_ID);
  constructor(private breakpointObserver: BreakpointObserver,
    private service: KbMyPriceListService, private cdr: ChangeDetectorRef,
    private endPointService: OccEndpointsService) {
    this.sub.add(
      this.breakpointObserver
        .observe([Breakpoints.XSmall, Breakpoints.Small])
        .subscribe((result) => {
          this.isMobile = result.matches;
        }));
    this.baseUrl = this.endPointService.getBaseUrl({
      baseUrl: true,
      prefix: false,
      baseSite: false,
    });
  }

  ngOnInit() {
    this.sub.add(this.service.getApi().subscribe((res: any) => {
      this.url = res;
      this.initializePricingArray();
      this.cdr.detectChanges();
    }))
  }

  initializePricingArray() {
    if (this.url && this.url.media) {
      this.Pricing = Array(this.url.media.length).fill(false);
    }
  }

  namefilter(filename): string {
    return filename.replace(/\..*/, '');
  }

  selectingAll() {
    this.selectAll = !this.selectAll;
    if (this.selectAll) {
      this.Pricing = this.Pricing.map(() => true);
    } else {
      this.Pricing = this.Pricing.map(() => false);
    }
  }
  transformObjectToDownloadItems(data: any[], baseUrl: string): DownloadItem[] {
    return data.map(item => ({
      download: baseUrl + item.downloadUrl,
      filename: item.code
    }));
  }

  downloadFiles() {
    const selectedFiles = this.url.media.filter((reports, index) => this.Pricing[index]);
    if (selectedFiles.length === 0) {
      return;
    } else {
      const downloadableFormat = this.transformObjectToDownloadItems(selectedFiles, this.baseUrl);
      this.downloadFile(downloadableFormat);
    }
  }

  downloadFile(files: { download: string; filename: string }[]) {
    if (isPlatformBrowser(this.platformId)) {
      async function downloadNext(i: number): Promise<void> {
        if (i >= files.length) {
          return;
        }

        const a = document.createElement('a');
        a.href = files[i].download;
        a.target = '_parent';
        if ('download' in a) {
          a.download = files[i].filename;
        }
        (document.body || document.documentElement).appendChild(a);
        if (a.click) {
          a.click();
        } else {
          (a as any).click();
        }
        a.parentNode?.removeChild(a);

        await new Promise(resolve => setTimeout(resolve, 1000));

        await downloadNext(i + 1);

      }
      downloadNext(0)
        .then(() => console.log("All downloads completed!"))
        .catch(error => console.error("Download error:", error));
    }

  }

}
